
<v-container
  ref="basewindow"
  fluid
  class="d-flex flex-column pa-0 ma-0"
  :class="{ resizing: isResizing }"
  :style="`height: 100vh; overflow: hidden;`"
>
  <transition name="fade">
    <VoxdubAnimation v-if="videoLoading" />
  </transition>

  <div class="menu-container">
    <MenuBar
      @resetSubtitles="resetSubtitles"
      @saveProject="saveProject"
      @exportToJson="exportToJson"
      @exportToSrt="exportToSrt"
      @exportToAss="exportToAss"
      @exportAudiosForBwf="exportAudiosForBwf"
      @configureBwfMetadata="configureBwfMetadata"
      @exportProject="exportProject"
      @importProject="importProject"
      @importDETX="importDETX"
      @exportDETX="exportDETX"
      @exportCroisille="exportCroisille"
      @openExportWindow="openExportWindow"
      @detectSceneChange="detectSceneChange"
      @detectSubtitles="detectSubtitles"
      @audioDenoiser="audioDenoiser"
      @audioRemoveVoice="audioRemoveVoice"
      @generateSubtitles="generateSubtitles"
      @generateAudio="generateAudio"
      @playVideo="playVideo"
      @incrementSpeedRate="incrementSpeedRate"
      @getAudioData="getAudioData"
      @openFriendInvite="inviteFriendModal = true"
      @openTaskPopup="taskPopup = true"
      @importSubtitles="importSubtitles"
      @openPopupPlan="openPopupPlan = $event"
      @openSettings="openSettings = $event"
      :lastSave="lastSave"
      :cinemaMode="cinemaMode"
      @cinemaModeEvent="cinemaMode = $event"
      @toggleVideoSubtitles="
        settings.showVideoSubtitles = !settings.showVideoSubtitles
      "
      @openHelpWindow="openHelpWindow = $event"
      :subtitles="subtitles"
      :video="$refs.video"
      :hasProcessedAudio="hasProcessedAudio"
      @restoreOriginalAudio="restoreOriginalAudio"
      @replaceVideoNoVocal="replaceVideoNoVocal"
      :settings="settings"
    />

    <!-- Barre secondaire avec tabs et infos -->
    <div
      class="secondary-bar d-flex align-center justify-space-between px-2 py-1"
    >
      <!-- Label section -->
      <div class="d-flex align-center flex-grow-0 flex-shrink-0" style="width: auto; flex: 0 0 auto">
        <v-icon small color="primary" class="mr-1">mdi-music-box</v-icon>
        <span class="text-caption font-weight-bold" style="color: #ccc;">Rythmo</span>
      </div>

      <!-- Zone du titre du projet au centre -->
      <div class="project-title-zone mx-3" style="min-width: 0">
        <v-icon x-small color="white" class="mr-1">mdi-movie-edit</v-icon>
        <span class="project-title-text">{{
          title || "Projet sans titre"
        }}</span>
      </div>

      <!-- Statut de sauvegarde à droite -->
      <div
        class="save-status-zone d-flex align-center justify-end flex-grow-0 flex-shrink-0"
        style="min-width: 220px"
        v-if="!$vuetify.breakpoint.mobile"
      >
        <v-chip small outlined class="mr-2 px-3" :color="autoSaveStatusColor">
          <v-icon x-small left>mdi-content-save-auto</v-icon>
          {{ autoSaveStatus }}
        </v-chip>
        <small class="save-time-text mr-1">{{
          $moment(lastSave * 1000).fromNow()
        }}</small>
        <template v-if="!saveInProgress">
          <v-btn
            @click="saveProject()"
            icon
            small
            :color="
              $moment().diff(lastSave * 1000, 'minutes') > 5 ? 'red' : 'green'
            "
          >
            <v-icon small>mdi-cloud-sync</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-progress-circular
            v-if="saveInProgress"
            :value="uploadProgress"
            color="primary"
            size="20"
          />
        </template>
      </div>
    </div>
  </div>
  <v-dialog
    v-model="error"
    top
    transition="dialog-bottom-transition"
    max-width="600px"
    persistent
    width="100%"
    :retain-focus="false"
  >
    <v-card dark>
      <v-card-title> </v-card-title>
      <v-card-text class="text-center">
        <span class="headline primary--text">{{ $t("error.title") }}</span>
        <h3>{{ $t("error.error_message") }}</h3>
        <!-- discord button -->
        <v-btn
          color="primary"
          class="mt-12"
          @click="window.open('https://discord.gg/RrmKMBsYFy', '_blank')"
        >
          {{ $t("help.join_us_on_discord") }} </v-btn
        ><br />
        Details<br />
        <code>
          {{ errorMessage }}
        </code>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="error = false">{{
          $t("button.close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <div class="fullscreen">
    <div class="containerapp">
      <div
        style="overflow: hidden"
        xs12
        :md6="!cinemaMode"
        class="pa-0 ma-0"
        :class="cinemaMode ? 'center' : 'column1'"
        :style="
          cinemaMode
            ? ''
            : `width: ${videoSectionWidth}%; transition: width 0.2s ease;`
        "
      >
        <div class="videocontainer">
          <!-- Video Editor -->
          <div id="videoCanvas" class="pa-0 ma-0 videocanvas">
            <v-row v-show="false">
              <v-col>
                <label>
                  Importer une video
                  <input
                    type="file"
                    ref="inputVideo"
                    @change="loadVideoBlob($event)"
                  />
                </label>
              </v-col>
            </v-row>
            <div
              class="pa-0 text-center ma-0 art-video-player"
              style="width: 100%; position: relative"
            >
              <video
                class="art-video"
                :muted="isRecording"
                style="
                  box-shadow: #e8497c24 1px 1px 32px;
                  width: 100%;
                  margin: auto;
                "
                crossorigin="anonymous"
                ref="video"
                webkit-playsinline
                playsinline
                controls
              >
                <source :src="videoSource" type="video/mp4" />
              </video>

              <!-- Overlay des sous-titres sur la vidéo -->
              <div
                class="video-subtitles-overlay"
                v-if="
                  settings.showVideoSubtitles &&
                  displayCurrentSubtitle &&
                  displayCurrentSubtitle.length
                "
              >
                <div
                  v-for="subtitle in displayCurrentSubtitle"
                  :key="`video-subtitle-${subtitle.id}`"
                  class="video-subtitle-text"
                  :style="getVideoSubtitleStyle(subtitle)"
                >
                  <span
                    class="subtitle-character"
                    v-if="subtitle.characterShow && subtitle.character"
                    :style="{
                      color:
                        settings.charactersColors[subtitle.character] ||
                        '#FCB6CD',
                    }"
                  >
                    {{ subtitle.character }}
                  </span>
                  <span
                    class="subtitle-content"
                    :class="{
                      'subtitle-underline': subtitle.underline,
                      'subtitle-dashed': subtitle.dashed,
                    }"
                    :style="{
                      fontFamily: settings.fontFamily,
                      color: settings.fontColor || '#ffffff',
                    }"
                  >
                    {{ subtitle.text }}
                  </span>
                </div>
              </div>

              <!-- Display filigrane -->
            </div>
          </div>
        </div>
      </div>

      <!-- Splitter vertical entre vidéo et sous-titres -->
      <ResizableSplitter
        v-if="!cinemaMode"
        direction="vertical"
        :min-size="innerWidth * 0.2"
        :max-size="innerWidth * 0.8"
        @resize="handleVerticalResize"
        @resize-start="onResizeStart"
        @resize-end="onResizeEnd"
      />

      <div
        v-show="!cinemaMode"
        xs12
        md6
        style="overflow: scroll"
        class="column2"
        :style="`width: ${subtitleSectionWidth}%; transition: width 0.2s ease;`"
      >
        <!-- Subtitle Editor -->
        <v-col class="pa-0 ma-0">
          <v-col class="mx-0 my-0 px-0 py-0">
            <v-col cols="12" v-show="false">
              <label>
                {{ $t("options.load_subtitles") }}
                <input
                  type="file"
                  ref="inputSousTitre"
                  @change="importFromJson($event)"
                />
              </label>
            </v-col>
            <!-- order subtitle by last id -->
            <v-col
              cols="12"
              class="pa-0 mx-0 mt-0"
              :style="{
                position: 'relative',
              }"
            >
              <!-- Panneau moderne du titre et des langues -->
              <div class="project-header-panel">
                <!-- Section principale avec titre et langue -->
                <div class="header-main-section">
                  <!-- Titre du projet -->
                  <div class="title-section">
                    <v-icon color="primary" class="title-icon mr-3"
                      >mdi-movie-edit</v-icon
                    >
                    <v-text-field
                      v-model="title"
                      hide-details
                      class="project-title-field"
                      placeholder="Nom du projet..."
                      outlined
                      dense
                      dark
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="primary" size="18">mdi-pencil</v-icon>
                      </template>
                    </v-text-field>
                  </div>

                  <!-- Sélection de langue -->
                  <div class="language-section">
                    <v-icon color="info" class="language-icon mr-2"
                      >mdi-translate</v-icon
                    >
                    <v-select
                      class="language-select"
                      hide-details
                      :items="getAvailableLanguage"
                      v-model="settings.language"
                      label="Langue"
                      outlined
                      dense
                      @change="changeSubtitlesLanguage"
                      dark
                    >
                      <template v-slot:prepend-inner>
                        <v-icon color="info" size="16">mdi-web</v-icon>
                      </template>
                      <template v-slot:append>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              small
                              icon
                              color="info"
                              v-on="on"
                              @click.stop
                              class="add-language-btn"
                              :title="$t('button.add_language')"
                            >
                              <v-icon small>mdi-plus-circle</v-icon>
                            </v-btn>
                          </template>
                          <v-list class="language-menu">
                            <v-list-item-group>
                              <v-list-item
                                v-for="lang in [
                                  'fr',
                                  'en',
                                  'de',
                                  'ja',
                                  'it',
                                  'es',
                                ]"
                                @click="
                                  $auth?.user?.role != 'pro' &&
                                  $auth?.user?.role != 'basic'
                                    ? (openPopupPlan = true)
                                    : createLanguage(lang)
                                "
                                :key="`lang${lang}`"
                                class="language-item"
                              >
                                <v-list-item-avatar size="32">
                                  <v-icon color="info">mdi-flag</v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title class="language-name">{{
                                    lang.toUpperCase()
                                  }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-icon color="success" size="16"
                                    >mdi-plus</v-icon
                                  >
                                </v-list-item-action>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </v-menu>
                      </template>
                    </v-select>
                  </div>
                </div>

                <!-- Section des actions -->
                <div class="header-actions-section">
                  <!-- Groupe d'actions principales -->
                  <div class="action-group primary-actions">
                    <!-- Ajouter un sous-titre -->
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="action-btn primary-btn"
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          outlined
                          small
                        >
                          <v-icon left size="16">mdi-text-box-plus</v-icon>
                          <span class="btn-text">Ajouter</span>
                        </v-btn>
                      </template>
                      <v-list class="subtitle-menu">
                        <v-list-item-group>
                          <v-list-item
                            v-for="(line, index) in [1, 2, 3, 4]"
                            :key="`line-${line}`"
                            @click="
                              createSubtitle('Text Here', index);
                              selectedSubtitle =
                                subtitles[subtitles.length - 1];
                              scrollTo(subtitles[subtitles.length - 1].id);
                            "
                            class="subtitle-line-item"
                          >
                            <v-list-item-avatar size="32">
                              <v-avatar color="primary" size="28">
                                <span class="white--text font-weight-bold">{{
                                  line
                                }}</span>
                              </v-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                >Ligne {{ line }}</v-list-item-title
                              >
                              <v-list-item-subtitle
                                >Ajouter un sous-titre sur la ligne
                                {{ line }}</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>

                    <!-- Édition en lot -->
                    <v-btn
                      class="action-btn secondary-btn"
                      :disabled="!selectedSubtitles.length"
                      @click="bulkEdit = !bulkEdit"
                      color="warning"
                      outlined
                      small
                    >
                      <v-icon left size="16">mdi-pencil-box-multiple</v-icon>
                      <span class="btn-text">Éditer</span>
                      <v-badge
                        v-if="selectedSubtitles.length"
                        :content="selectedSubtitles.length"
                        color="warning"
                        overlap
                        class="ml-1"
                      ></v-badge>
                    </v-btn>
                  </div>

                  <!-- Indicateur de statut -->
                  <div class="status-indicators">
                    <v-chip
                      small
                      color="success"
                      outlined
                      class="status-chip"
                    >
                      <v-icon left size="14">mdi-check-circle</v-icon>
                      {{ subtitles.length }} sous-titres
                    </v-chip>

                    <!-- Indicateur de complétion du doublage -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          small
                          :color="
                            dubbingCompletionPercentage === 100
                              ? 'success'
                              : dubbingCompletionPercentage >= 50
                              ? 'warning'
                              : 'error'
                          "
                          outlined
                          class="status-chip"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon left size="14">mdi-microphone</v-icon>
                          {{ dubbingCompletionPercentage }}% doublé
                        </v-chip>
                      </template>
                      <span
                        >{{ getSubtitlesWithAudioCount() }}/{{
                          subtitles.length
                        }}
                        sous-titres ont un doublage audio</span
                      >
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col
              ref="scrollableSub"
              :style="`width:${subtitleWidth}px;`"
              class="subtitle mx-0 pb-16 my-0 px-0"
            >
              <draggable
                v-model="subtitles"
                group="people"
                @start="drag = true"
                @end="drag = false"
                handle=".drag-handle-compact"
              >
                <v-col
                  v-for="(subtitle, b) in subtitlesOrdered"
                  :key="`scrollsub${b}`"
                  no-action
                  class="pa-0 px-2 ma-0"
                >
                  <SubtitleEditorComponent
                    @update:subtitle="subtitle = $event"
                    @seekToTime="handleSeekToTime($event)"
                    @update:selectedSubtitles="selectedSubtitles = $event"
                    :selectedSubtitles="selectedSubtitles"
                    @deleteSubtitle="deleteSubtitle($event)"
                    @update:speakingRateChange="speakingRateChange($event)"
                    @deleteAudioSource="deleteAudioSource($event)"
                    @update:selectedCharacter="selectedCharacter = $event"
                    @update:selectedSubtitle="selectedSubtitle = $event"
                    @openRecordingStudio="openRecordingStudioForSubtitle"
                    :subtitle="subtitle"
                    :characters="getArrayOfAvailableCharacter"
                    :index="b"
                    :selectedSubtitle="selectedSubtitle"
                    :settings="settings"
                    :sources="sources"
                    :isRecording="isRecording"
                    :selectedCharacter="selectedCharacter"
                  />
                </v-col>
              </draggable>
              <v-col v-if="!subtitlesOrdered.length">
                <v-card elevation="0">
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" class="text-center">
                        <v-btn
                          fab
                          elevation="0"
                          color="primary"
                          v-if="false"
                          @click="
                            createSubtitle('Text Here');
                            selectedSubtitle =
                              subtitles[subtitles.length - 1];
                            scrollTo(subtitles[subtitles.length - 1].id);
                          "
                        >
                          <v-icon x-large color="white">
                            mdi-text-box-plus
                          </v-icon>
                        </v-btn>
                        <!-- Ajouter un sous-titre avec dropdown menu -->
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              title="Ajouter un sous-titre"
                              fab
                              elevation="0"
                              v-bind="attrs"
                              class="ml-6"
                              v-on="on"
                              color="primary"
                            >
                              <v-icon x-large> mdi-text-box-plus </v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item
                              @click="
                                createSubtitle('Text Here', 0);
                                selectedSubtitle =
                                  subtitles[subtitles.length - 1];
                                scrollTo(subtitles[subtitles.length - 1].id);
                              "
                            >
                              <v-list-item-title> Ligne 1 </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="
                                createSubtitle('Text Here', 1);
                                selectedSubtitle =
                                  subtitles[subtitles.length - 1];
                                scrollTo(subtitles[subtitles.length - 1].id);
                              "
                            >
                              <v-list-item-title> Ligne 2 </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              @click="
                                createSubtitle('Text Here', 2);
                                selectedSubtitle =
                                  subtitles[subtitles.length - 1];
                                scrollTo(subtitles[subtitles.length - 1].id);
                              "
                            >
                              <v-list-item-title> Ligne 3 </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <h3 class="primary--text">
                          {{ $t("subtitle_editor.no_subtitle") }}
                        </h3>
                        <p>
                          {{ $t("subtitle_editor.no_subtitle_description") }}
                        </p>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col class="mb-16"></v-col>
            </v-col>
            <v-col
              cols="12"
              style="max-height: 20vh; overflow: scroll"
              v-if="false"
            >
              <v-list dense>
                <v-list-group
                  v-for="(character, b) in getArrayOfAvailableCharacter"
                  :key="`availabchara${b}`"
                >
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ character }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-col cols="12">
                    <v-btn
                      fab
                      color="red"
                      small
                      @click="recordAudio(character)"
                    >
                      <v-icon small>
                        <!-- audio record -->
                        mdi-microphone
                      </v-icon>
                    </v-btn>
                    <br />
                    <template
                      v-if="
                        sources.find(
                          (map) => map.character == character && !map.subtitle
                        )?.src
                      "
                    >
                      <v-card class="secondary" elevation="0">
                        <v-card-text>
                          <v-subheader class="mt-0 pt-0">
                            {{ $t("title.audio") }}
                          </v-subheader>
                          <v-btn
                            color="red"
                            icon
                            style="
                              position: absolute;
                              right: 2em;
                              top: 2em;
                              cursor: pointer;
                              z-index: 100000;
                            "
                            @click="
                              deleteAudioSource(
                                null,
                                sources.find(
                                  (map) =>
                                    map.character == character &&
                                    !map.subtitle
                                )?.src
                              )
                            "
                          >
                            <v-icon style="cursor: pointer" small
                              >mdi-delete</v-icon
                            >
                          </v-btn>
                          <!-- audio player -->
                          <wave-surfer
                            :height="50"
                            :interact="false"
                            :source="
                              sources.find(
                                (map) =>
                                  map.character == character && !map.subtitle
                              )?.src
                            "
                          />
                          <audio
                            preload="auto"
                            :muted="isRecording"
                            class="mt-12"
                            :id="`audio${character}`"
                            :ref="`audio${character}`"
                            :src="
                              sources.find(
                                (map) =>
                                  map.character == character && !map.subtitle
                              )?.src
                            "
                            crossorigin="anonymous"
                            controls
                          ></audio>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-col>
                </v-list-group>
              </v-list>
            </v-col>
          </v-col>
        </v-col>
      </div>
    </div>

    <!-- Splitter horizontal pour la section rythmo -->
    <ResizableSplitter
      direction="horizontal"
      :min-size="200"
      :max-size="innerHeight - 200"
      @resize="handleHorizontalResize"
      @resize-start="onResizeStart"
      @resize-end="onResizeEnd"
    />

    <!-- Audio Toggle -->
    <div
      style="flex: 0 0 20px; height: 20px; background: #111; display: flex; align-items: center; justify-content: center; cursor: pointer; border-top: 1px solid #333;"
      @click="toggleAudioTracks"
    >
      <span style="font-size: 10px; color: #888; user-select: none;">
        Audio
        <span :style="{ display: 'inline-block', transform: showAudioTracks ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 0.2s' }">▼</span>
      </span>
    </div>
    <!-- Audio Tracks (inline) -->
    <div
      v-show="showAudioTracks"
      style="flex: 0 0 40px; height: 40px; background: #1a1a1a; border-top: 2px solid #e74970; overflow: hidden; white-space: nowrap;"
      ref="audioTracksScroll"
    >
      <div :style="`width: ${innerWidth / 2}px; display: inline-block; height: 100%;`"></div>
      <div :style="`width: ${videoDuration * 25 * settings.fontSize}px; display: inline-block; position: relative; height: 100%;`">
        <!-- Recording indicator bar -->
        <div
          v-if="isRecording"
          :style="{
            position: 'absolute',
            left: (startRecording * 25 * settings.fontSize) + 'px',
            width: (recordingTime * 25 * settings.fontSize) + 'px',
            height: '36px',
            top: '2px',
            backgroundColor: 'rgba(231, 73, 112, 0.4)',
            borderRadius: '3px',
            border: '1px solid #e74970',
            transition: 'width 0.1s linear',
          }"
        >
          <span style="font-size: 9px; color: #e74970; padding: 2px 4px; font-weight: bold;">REC</span>
        </div>
        <div
          v-for="source in audioSources"
          :key="'at-' + source.id"
          class="audio-track-segment"
          :style="{
            position: 'absolute',
            left: (source.start * 25 * settings.fontSize) + 'px',
            width: ((source.end - source.start) * 25 * settings.fontSize) + 'px',
            height: '36px',
            top: '2px',
            backgroundColor: hexToRgba(settings.charactersColors[source.character] || '#6449D1', 0.6),
            borderRadius: '3px',
            border: '1px solid ' + (settings.charactersColors[source.character] || '#6449D1'),
            fontSize: '9px',
            color: 'rgba(255,255,255,0.7)',
            padding: '2px 4px',
            overflow: 'hidden',
            cursor: 'grab',
          }"
          @mousedown="startAudioSegmentDrag($event, source)"
        >
          <audio
            :ref="`audioPlayer${source.character}${source.id}`"
            :src="source.src"
            preload="auto"
            style="display: none;"
          ></audio>
          <wave-surfer
            :ref="`audioTrackWs_${source.id}`"
            :source="source.src"
            :height="32"
            :interact="false"
            :muted="true"
            :waveColor="settings.charactersColors[source.character] || '#aaa'"
            :progressColor="'rgba(255,255,255,0.3)'"
            :cursorColor="'transparent'"
            :cursorWidth="0"
            :options="{ waveColor: settings.charactersColors[source.character] || '#aaa' }"
            :style="{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }"
          />
          <v-btn
            icon
            x-small
            class="audio-segment-delete"
            @click.stop="deleteAudioSource(source.id)"
            title="Supprimer"
            :style="{ position: 'absolute', top: '2px', right: '2px', zIndex: 10, opacity: 0, transition: 'opacity 0.15s' }"
          >
            <v-icon x-small color="white">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div
      class="rowbottom"
      ref="rowbottom"
      :style="`height: ${rythmoSectionHeight}vh; transition: height 0.2s ease; --rythmo-height: ${rythmoSectionHeight}vh;`"
    >
      <div class="column3" lg12>
        <v-col class="pa-0 ma-0">
          <v-toolbar
            ref="rythmoToolbar"
            v-if="!cinemaMode"
            dense
            style="max-width: 100vw; overflow-x: scroll; overflow-y: hidden"
            class="rythmo-toolbar"
          >
            <!-- Section Enregistrement Audio Simple -->
            <DubbingRecorder
              :characters="getArrayOfAvailableCharacter"
              :charactersColors="settings.charactersColors"
              :video="$refs.video"
              :subtitles="subtitles"
              :initialCharacter="selectedCharacter"
              @recording-start="onDubbingRecordingStart"
              @recording-tick="recordingTime = $event"
              @recording-done="onDubbingRecordingDone"
              @error="onDubbingRecordingError"
              ref="dubbingRecorder"
            />
            <v-divider vertical class="mx-2"></v-divider>

            <!-- add subtitle -->
            <v-btn
              fab
              x-small
              elevation="0"
              color="primary"
              v-if="false"
              @click="
                createSubtitle('Text Here');
                selectedSubtitle = subtitles[subtitles.length - 1];
                scrollTo(subtitles[subtitles.length - 1].id);
              "
            >
              <v-icon small>mdi-text-box-plus</v-icon>
            </v-btn>
            <!-- Ajouter un sous-titre avec dropdown menu -->
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  title="Ajouter un sous-titre"
                >
                  <v-icon> mdi-text-box-plus </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="line in [1, 2, 3, 4]"
                  :key="`line-${line}`"
                  @click="
                    createSubtitle('Text Here', line - 1);
                    selectedSubtitle = subtitles[subtitles.length - 1];
                    scrollTo(subtitles[subtitles.length - 1].id);
                  "
                >
                  <v-list-item-title> Ligne {{ line }} </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- videoSpeedRate -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab x-small elevation="0" @click="incrementSpeedRate()" v-bind="attrs" v-on="on">
                  x{{ videoSpeedRate }}
                </v-btn>
              </template>
              <span>Vitesse de lecture</span>
            </v-tooltip>
            <!-- Playback -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  v-if="videoPaused"
                  @click="playVideo()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-play</v-icon>
                </v-btn>
                <v-btn v-else fab x-small elevation="0" @click="playVideo()" v-bind="attrs" v-on="on">
                  <v-icon>mdi-pause</v-icon>
                </v-btn>
              </template>
              <span>{{ videoPaused ? 'Lecture' : 'Pause' }}</span>
            </v-tooltip>
            <!-- go to start -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  @click="$refs.video.currentTime = 0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-skip-backward</v-icon>
                </v-btn>
              </template>
              <span>Retour au debut</span>
            </v-tooltip>
            <!-- Forward -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  @click="$refs.video.currentTime -= 1 / base_rate"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-skip-previous</v-icon>
                </v-btn>
              </template>
              <span>Image precedente</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  @click="$refs.video.currentTime += 1 / base_rate"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-skip-next</v-icon>
                </v-btn>
              </template>
              <span>Image suivante</span>
            </v-tooltip>
            <!-- go to end -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  elevation="0"
                  @click="$refs.video.currentTime = $refs.video.duration"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-skip-forward</v-icon>
                </v-btn>
              </template>
              <span>Aller a la fin</span>
            </v-tooltip>
            <!-- /Playback -->
            <!-- editing subtitles -->
            <v-btn
              v-if="false"
              fab
              x-small
              elevation="0"
              @click="cutMode = !cutMode"
              :color="cutMode ? 'primary' : ''"
            >
              <v-icon>mdi-content-cut</v-icon>
            </v-btn>
            <!-- editing subtitles -->
            <v-btn
              class="ml-3"
              fab
              x-small
              elevation="0"
              @click="addItem('↑')"
              v-if="false"
            >
              ↑
            </v-btn>
            <v-btn
              fab
              x-small
              elevation="0"
              @click="addItem('↓')"
              v-if="false"
            >
              ↓
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab x-small elevation="0" @click="addLoop()" v-bind="attrs" v-on="on">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    viewBox="0 0 74.263 89"
                  >
                    <path
                      id="Tracé_9"
                      data-name="Tracé 9"
                      d="M0,0,58,58"
                      transform="translate(8.132 13)"
                      fill="none"
                      stroke="red"
                      stroke-width="5"
                    />
                    <line
                      id="Ligne_30"
                      data-name="Ligne 30"
                      y1="58"
                      x2="58"
                      transform="translate(8.132 13)"
                      fill="none"
                      stroke="red"
                      stroke-width="5"
                    />
                    <line
                      id="Ligne_31"
                      data-name="Ligne 31"
                      y2="89"
                      transform="translate(37.132)"
                      fill="none"
                      stroke="red"
                      stroke-width="5"
                    />
                  </svg>
                </v-btn>
              </template>
              <span>Ajouter une boucle</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab x-small elevation="0" @click="addEndDialog()" v-bind="attrs" v-on="on">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.235"
                    height="20"
                    viewBox="0 0 65.235 109"
                  >
                    <rect
                      id="Rectangle_55"
                      data-name="Rectangle 55"
                      width="10"
                      height="104"
                      transform="translate(35.235 5)"
                      fill="#c43636"
                    />
                    <line
                      id="Ligne_19"
                      data-name="Ligne 19"
                      y1="66.494"
                      x2="66.948"
                      transform="translate(1.762 14)"
                      fill="none"
                      stroke="#c43636"
                      stroke-width="10"
                    />
                    <line
                      id="Ligne_73"
                      data-name="Ligne 73"
                      y1="67"
                      x2="66.774"
                      transform="translate(12.735 33.5)"
                      fill="none"
                      stroke="#c43636"
                      stroke-width="10"
                    />
                  </svg>
                </v-btn>
              </template>
              <span>Fin de dialogue</span>
            </v-tooltip>
            <v-btn fab x-small elevation="0" @click="addSvg(1)" v-if="false">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 44.679 37.844"
              >
                <g
                  id="Composant_12_1"
                  data-name="Composant 12 – 1"
                  transform="translate(1.36 2)"
                >
                  <g
                    id="Groupe_20"
                    data-name="Groupe 20"
                    transform="translate(0 7.685)"
                  >
                    <line
                      id="Ligne_36"
                      data-name="Ligne 36"
                      x2="41.966"
                      y2="25.449"
                      transform="translate(0 1)"
                      fill="none"
                      stroke="#fff"
                      stroke-width="4"
                    />
                    <line
                      id="Ligne_37"
                      data-name="Ligne 37"
                      y1="26.449"
                      x2="41.966"
                      transform="translate(0 0)"
                      fill="none"
                      stroke="#fff"
                      stroke-width="4"
                    />
                  </g>
                  <path
                    id="Tracé_11"
                    data-name="Tracé 11"
                    d="M0-8.452s10.438-9.686,20.93-9.686S41.966-8.452,41.966-8.452"
                    transform="translate(0 18.138)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="4"
                  />
                </g>
              </svg>
            </v-btn>
            <v-btn fab x-small elevation="0" @click="addSvg(2)" v-if="false">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                viewBox="0 0 42.934 10.068"
              >
                <path
                  id="Tracé_12"
                  data-name="Tracé 12"
                  d="M0-11.769s10.153-6.369,20.357-6.369,20.46,6.369,20.46,6.369"
                  transform="translate(1.063 20.138)"
                  fill="none"
                  stroke="#fff"
                  stroke-width="4"
                />
              </svg>
            </v-btn>
            <v-btn fab x-small elevation="0" @click="addSvg(3)" v-if="false">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                viewBox="0 0 44.729 13.386"
              >
                <path
                  id="Tracé_13"
                  data-name="Tracé 13"
                  d="M0,0S10.473,9.932,20.968,9.932,41.979,0,41.979,0"
                  transform="translate(1.376 1.454)"
                  fill="none"
                  stroke="#fff"
                  stroke-width="4"
                />
              </svg>
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab x-small elevation="0" @click="addSceneChange()" v-bind="attrs" v-on="on">
                  |
                </v-btn>
              </template>
              <span>Changement de scene</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab x-small elevation="0" @click="addNote('«TEXT»')" v-bind="attrs" v-on="on">
                  «»
                </v-btn>
              </template>
              <span>Ajouter une note</span>
            </v-tooltip>
            <!-- dropdown -->
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small elevation="0" v-bind="attrs" v-on="on" title="Symboles de respiration">
                  RESPIRATIONS
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="addItem('↗')">
                  <v-list-item-title> ↗ </v-list-item-title>
                </v-list-item>
                <v-list-item @click="addItem('↘')">
                  <v-list-item-title> ↘ </v-list-item-title>
                </v-list-item>
                <v-list-item @click="createSubtitle('(H)')">
                  <v-list-item-title> (H) </v-list-item-title>
                </v-list-item>
                <v-list-item @click="createSubtitle('(HH)')">
                  <v-list-item-title> (HH) </v-list-item-title>
                </v-list-item>
                <v-list-item @click="createSubtitle('(mH)')">
                  <v-list-item-title> (mH) </v-list-item-title>
                </v-list-item>
                <v-list-item @click="createSubtitle('(mHH)')">
                  <v-list-item-title> (mHH) </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small elevation="0" v-bind="attrs" v-on="on" title="Reactions sonores">
                  RÉACTIONS
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="react in reactions"
                  :key="react"
                  @click="createSubtitle(react)"
                >
                  <v-list-item-title>
                    {{ react }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab x-small elevation="0" @click="addItem('↦')" v-bind="attrs" v-on="on">
                  <span
                    :style="{
                      fontSize: '2em',
                    }"
                  >
                    ↦
                  </span>
                </v-btn>
              </template>
              <span>Liaison a droite</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab x-small elevation="0" @click="addItem('↤')" v-bind="attrs" v-on="on">
                  <span
                    :style="{
                      fontSize: '2em',
                    }"
                  >
                    ↤
                  </span>
                </v-btn>
              </template>
              <span>Liaison a gauche</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  class="mr-3"
                  elevation="0"
                  :color="deleteItems ? 'red' : ''"
                  @click="enableDeleteItems()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon x-small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Supprimer des elements</span>
            </v-tooltip>

            <!-- Bouton mode dessin -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  class="mr-3"
                  elevation="0"
                  :color="drawingMode ? 'primary' : ''"
                  @click="toggleDrawingMode()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon x-small v-if="$auth?.user?.role === 'pro'"
                    >mdi-brush</v-icon
                  >
                  <v-icon x-small v-else>mdi-lock</v-icon>
                </v-btn>
              </template>
              <span>{{
                $auth?.user?.role !== 'pro'
                  ? 'Fonctionnalite reservee aux abonnes Pro'
                  : drawingMode
                  ? 'Desactiver le mode dessin'
                  : 'Activer le mode dessin'
              }}</span>
            </v-tooltip>

            <!-- Bouton mode double bande rythmo -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  x-small
                  class="mr-1"
                  elevation="0"
                  :color="doubleBandMode ? 'primary' : ''"
                  @click="toggleDoubleBandMode()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon x-small>mdi-view-split-horizontal</v-icon>
                </v-btn>
              </template>
              <span>{{ doubleBandMode ? 'Desactiver le mode double bande' : 'Activer le mode double bande' }}</span>
            </v-tooltip>

            <!-- Sélecteurs de langues pour le mode double bande -->
            <v-menu
              v-if="doubleBandMode"
              offset-y
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-chip small v-bind="attrs" v-on="on" class="mr-1" title="Configurer les langues source et cible">
                  <v-icon left x-small>mdi-translate</v-icon>
                  {{ sourceLang }} → {{ targetLang }}
                  <v-icon right x-small>mdi-menu-down</v-icon>
                </v-chip>
              </template>
              <v-card width="300">
                <v-card-text>
                  <v-select
                    v-model="sourceLang"
                    :items="
                      getAvailableLanguage.filter(
                        (lang) => lang !== targetLang
                      )
                    "
                    label="Langue source (originale)"
                    dense
                    outlined
                    @change="loadDoubleBandSubtitles"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="primary">mdi-lock-outline</v-icon>
                    </template>
                  </v-select>
                  <v-select
                    v-model="targetLang"
                    :items="
                      getAvailableLanguage.filter(
                        (lang) => lang !== sourceLang
                      )
                    "
                    label="Langue cible (traduction)"
                    dense
                    outlined
                    @change="loadDoubleBandSubtitles"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small color="success"
                        >mdi-pencil-outline</v-icon
                      >
                    </template>
                  </v-select>

                  <v-divider class="my-3"></v-divider>

                  <div class="text-caption grey--text mb-2">
                    Ratio de division des bandes
                  </div>
                  <v-slider
                    v-model="rythmoSplitRatio"
                    :min="20"
                    :max="80"
                    :step="5"
                    thumb-label
                    prepend-icon="mdi-view-split-horizontal"
                    class="mt-1"
                  >
                    <template v-slot:append>
                      <span class="text-caption"
                        >{{ rythmoSplitRatio }}%</span
                      >
                    </template>
                  </v-slider>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    small
                    color="primary"
                    @click="
                      $event.target
                        .closest('.v-menu')
                        .querySelector('.v-menu__activator')
                        .click()
                    "
                  >
                    Fermer
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>

            <v-spacer />
            <v-btn
              x-small
              outlined
              color="error"
              class="mr-1"
              v-for="(loop, b) in ndd.loops"
              :key="`button${loop.x}`"
              @click="
                $refs.video.currentTime =
                  loop.x / (base_rate * settings.fontSize)
              "
              :title="`Aller a la boucle ${b + 1}`"
            >
              {{ b + 1 }}
            </v-btn>
            <!-- vertical slider height -->
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small elevation="0" v-bind="attrs" v-on="on" title="Hauteur de la bande rythmo">
                  <v-icon small> mdi-arrow-expand-vertical </v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="settings.height = 100">
                  <v-list-item-title> 100px </v-list-item-title>
                </v-list-item>
                <v-list-item @click="settings.height = 150">
                  <v-list-item-title> 150px </v-list-item-title>
                </v-list-item>
                <v-list-item @click="settings.height = 200">
                  <v-list-item-title> 200px </v-list-item-title>
                </v-list-item>
                <v-list-item @click="settings.height = 250">
                  <v-list-item-title> 250px </v-list-item-title>
                </v-list-item>
                <v-list-item @click="settings.height = 300">
                  <v-list-item-title> 300px </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
          <!-- cursor -->
          <div
            :style="`height:${
              rythmoElementHeight + 15
            }px;background-color:#e74970;border-radius:20px;box-shadow: 1px 1px 4px black;width:${
              5 / zoom
            }px;position:absolute;left:${innerWidth / 2}px;z-index:200;`"
          >
            <div style="position: absolute">
              <!-- timer -->
            </div>
          </div>
          <!-- Rythmo band (dialogues) -->
          <div class="rythmo-band-content">
              <div
                style="width: 100%; overflow-x: hidden; overflow-y: hidden"
                :style="`transform:scaleX(${zoom}); width:${
                  100 / zoom
                }%; height:${
                  rythmoElementHeight + 15
                }px; transform-origin:left;white-space: nowrap;`"
                ref="offsetDiv"
                id="offsetDiv"
              >
                <!-- Subtitles -->
                <div
                  :style="`width:${innerWidth / 2}px;display:inline-block;`"
                >
                  <div
                    class="timeline-cell"
                    id="timeline"
                    @click="scrollToTimeline"
                    :style="`left:${
                      offsetDuration * 100
                    }px;position:relative;width:100%;height:${rythmoElementHeight}px;`"
                  ></div>
                </div>
                <div
                  ref="rythmo"
                  :style="{
                    width:
                      videoDuration * base_rate * settings.fontSize + 'px',
                    height: `${rythmoElementHeight}px`,
                    display: 'inline-block',
                  }"
                  v-touch="{
                    start: (e) => swipeMove(e),
                    end: (e) => swipeMove(e),
                    move: (e) => swipeMove(e),
                  }"
                >
                  <div
                    v-if="videoSource"
                    class="base-audio-wave"
                    :style="`width:${
                      videoDuration * base_rate * settings.fontSize
                    }px;position:absolute;top:${
                      settings.height
                    }px;opacity:1;height:60px;pointer-events: none;`"
                  >
                    <wave-surfer
                      :source="videoSource"
                      :height="60"
                      :interact="false"
                      @click="scrollToTimeline"
                      :muted="true"
                      ref="baseaudio"
                      :options="{ waveColor: '#ffffff' }"
                      :style="{
                        touchAction: 'none',
                        // position: 'relative',
                        // pointerEvent: 'none',
                        backgroundColor: 'rgba(12,12,12,0)',
                        borderRadius: '10px',
                      }"
                      :waveColor="'rgba(100, 100, 100, .3)'"
                      :progressColor="'rgba(100, 100, 100, .3)'"
                      :cursorColor="'rgba(0,0,0,0)'"
                    />
                  </div>

                  <!-- Canvas de dessin -->
                  <DrawingCanvas
                    ref="drawingCanvas"
                    :canvasWidth="
                      videoDuration * base_rate * settings.fontSize
                    "
                    :canvasHeight="rythmoElementHeight"
                    :currentTime="videoTime"
                    :videoDuration="videoDuration"
                    :offsetDuration="offsetDuration"
                    :enabled="drawingMode"
                    :showToolbar="drawingMode"
                    :zIndex="200"
                    :style="{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      zIndex: 200,
                      opacity: 1,
                      visibility: 'visible',
                    }"
                    @drawingStart="onDrawingStart"
                    @drawing="onDrawing"
                    @drawingEnd="onDrawingEnd"
                    @canvasCleared="onCanvasCleared"
                    @canvasExported="onCanvasExported"
                    @canvasReady="onCanvasReady"
                  />

                  <div
                    style="
                      position: absolute;
                      top: -10px;
                      width: 100%;
                      z-index: 100;
                    "
                    v-if="$refs.video && $refs.video.duration"
                  >
                    <!-- each frame tick -->
                    <template v-if="false">
                      <div
                        :style="`width:${settings.fontSize}px; ${
                          i % base_rate == 0 ? 'color:red;' : 'color:grey;'
                        }${
                          i % 2 == 0 ? 'height:15px;' : 'height:20px;'
                        }overflow:hidden;position:absolute;left:${
                          i * settings.fontSize
                        }px;`"
                        style="z-index: 100000; color: white"
                        v-for="(time, i) in Math.round(
                          $refs.video.duration * base_rate
                        )"
                        :key="`timeline${i}`"
                      >
                        |
                      </div>
                    </template>
                  </div>
                  <div
                    style="position: absolute; width: 100%; z-index: 100"
                    v-if="$refs.video && $refs.video.duration"
                  >
                    <!-- timeline tick bar -->
                    <template v-if="false">
                      <div
                        v-for="(time, i) in Math.round(
                          videoDuration * base_rate
                        )"
                        :style="`width:${
                          base_rate * settings.fontSize
                        }px;position:absolute;left:${
                          i * base_rate * settings.fontSize -
                          settings.fontSize * 1.5
                        }px;top:-20px;`"
                        style="
                          display: inline-block;
                          z-index: 100000;
                          color: white;
                        "
                        :key="`timeline${i}`"
                      >
                        <!-- timeline 00:00:00 -->
                        {{ $moment(i * 1000).format("HH:mm:ss") }}
                      </div>
                    </template>
                  </div>
                  <div
                    id="replace-item"
                    class="replace-item"
                    :data-id="item.id"
                    data-type="items"
                    :data-x="item.x"
                    :data-y="item.y"
                    style="z-index: 1000; position: absolute"
                    :style="`transform:translate(${item.x}px, ${item.y}px);font-size:2em;filter:contrast(0);`"
                    v-for="(item, i) in ndd.items"
                    :key="`ndd${i}`"
                  >
                    <v-btn
                      v-if="deleteItems"
                      @click="
                        ndd.items = ndd.items.filter((e) => e.id != item.id)
                      "
                      fab
                      x-small
                      elevation="0"
                      color="error"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    {{ item.text }}
                  </div>
                  <div
                    id="replace-item"
                    class="replace-item"
                    :data-id="item.id"
                    data-type="notes"
                    :data-x="item.x"
                    :data-y="item.y"
                    style="z-index: 1000; position: absolute"
                    :style="`transform:translate(${item.x}px, ${item.y}px);`"
                    v-for="(item, z) in ndd.notes"
                    :key="`note${item.x}-${z}`"
                  >
                    <v-btn
                      v-if="deleteItems"
                      @click="
                        ndd.notes = ndd.notes.filter((e) => e.id != item.id)
                      "
                      fab
                      x-small
                      elevation="0"
                      color="error"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-chip>
                      <v-text-field
                        v-if="item.active"
                        :style="{
                          width: 'auto',
                        }"
                        v-model="item.text"
                        dense
                        @blur="item.active = false"
                        hide-details
                      ></v-text-field>
                      <span
                        @click="
                          ($event) => {
                            item.active = true;
                            $nextTick(() => {
                              $event.target.focus();
                            });
                          }
                        "
                        v-else
                      >
                        {{ item.text }}
                      </span>
                    </v-chip>
                  </div>
                  <div
                    class="scenechange"
                    :style="`position:absolute;top:0;transform:translate(${sceneChange.x}px, 0px);height:${getDetectionMarkerHeight()}px;width:5px;background-color:grey; z-index:1000;`"
                    v-for="sceneChange in ndd.sceneChanges"
                    :key="`scene${sceneChange.x}`"
                  >
                    <v-btn
                      style="position: absolute; top: 0"
                      v-if="deleteItems"
                      @click="
                        ndd.sceneChanges = ndd.sceneChanges.filter(
                          (e) => e.id != sceneChange.id
                        )
                      "
                      fab
                      x-small
                      elevation="0"
                      color="error"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  <div
                    class="loop"
                    :style="`position:absolute;top:0;transform:translate(${loop.x}px, 0px);height:${getDetectionMarkerHeight()}px;width:2px;background-color:red; z-index:1000;`"
                    v-for="(loop, c) in ndd.loops"
                    :key="`loop${loop.x}`"
                  >
                    <v-btn
                      v-if="deleteItems"
                      @click="
                        ndd.loops = ndd.loops.filter((e) => e.id != loop.id)
                      "
                      fab
                      x-small
                      elevation="0"
                      color="error"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <div
                      :style="{
                        left: '-36px',
                        top: '50%',
                        position: 'absolute',
                        transform: 'translate(0, -50%)',
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="74.263"
                        height="40"
                        viewBox="0 0 74.263 89"
                      >
                        <path
                          id="Tracé_9"
                          data-name="Tracé 9"
                          d="M0,0,58,58"
                          transform="translate(8.132 13)"
                          fill="none"
                          stroke="red"
                          stroke-width="5"
                        />
                        <line
                          id="Ligne_30"
                          data-name="Ligne 30"
                          y1="58"
                          x2="58"
                          transform="translate(8.132 13)"
                          fill="none"
                          stroke="red"
                          stroke-width="5"
                        />
                        <line
                          id="Ligne_31"
                          data-name="Ligne 31"
                          y2="89"
                          transform="translate(37.132)"
                          fill="none"
                          stroke="red"
                          stroke-width="5"
                        />
                        <text
                          id="OUT"
                          transform="translate(84.235 26)"
                          fill="#b5423c"
                          font-size="27"
                          font-family="HelveticaNeue, Helvetica Neue"
                        >
                          <tspan x="0" y="0">{{ c + 1 }}</tspan>
                        </text>
                      </svg>
                    </div>
                  </div>
                  <div
                    class="endDialog"
                    :style="`position:absolute;top:0;transform:translate(${endDialog.x}px, 0px);height:${getDetectionMarkerHeight()}px;width:2px;background-color:red; z-index:1000;`"
                    v-for="endDialog in ndd.endDialog"
                    :key="`endDialog${endDialog.x}`"
                  >
                    <v-btn
                      v-if="deleteItems"
                      @click="
                        ndd.endDialog = ndd.endDialog.filter(
                          (e) => e.id != endDialog.id
                        )
                      "
                      fab
                      x-small
                      elevation="0"
                      color="error"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <div
                      :style="{
                        left: '-25px',
                        top: '50%',
                        position: 'absolute',
                        transform: 'translate(0, -50%)',
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="74.263"
                        height="40"
                        viewBox="0 0 140.235 102.265"
                      >
                        <line
                          id="Ligne_19"
                          data-name="Ligne 19"
                          y1="66.494"
                          x2="66.948"
                          transform="translate(1.762 14)"
                          fill="none"
                          stroke="#c43636"
                          stroke-width="5"
                        />
                        <line
                          id="Ligne_73"
                          data-name="Ligne 73"
                          y1="67"
                          x2="66.774"
                          transform="translate(12.735 33.5)"
                          fill="none"
                          stroke="#c43636"
                          stroke-width="5"
                        />
                        <text
                          id="OUT"
                          transform="translate(84.235 26)"
                          fill="#b5423c"
                          font-size="27"
                          font-family="HelveticaNeue, Helvetica Neue"
                        >
                          <tspan x="0" y="0">OUT</tspan>
                        </text>
                      </svg>
                    </div>
                  </div>
                  <div
                    id="replace-item"
                    class="replace-item"
                    :data-id="item.id"
                    data-type="svg"
                    :data-x="item.x"
                    :data-y="item.y"
                    style="z-index: 1000; position: absolute"
                    :style="`transform:translate(${item.x}px, ${item.y}px);`"
                    v-for="(item, z) in ndd.svg"
                    :key="`note${z}`"
                  >
                    <v-btn
                      v-if="deleteItems"
                      @click="
                        ndd.svg = ndd.svg.filter((e) => e.id != item.id)
                      "
                      fab
                      x-small
                      elevation="0"
                      color="error"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <template v-if="item.svg == 1">
                      <svg
                        :style="{
                          filter: 'contrast(0)',
                        }"
                        xmlns="http://www.w3.org/2000/svg"
                        height="20"
                        viewBox="0 0 44.679 37.844"
                      >
                        <g
                          id="Composant_12_1"
                          data-name="Composant 12 – 1"
                          transform="translate(1.36 2)"
                        >
                          <g
                            id="Groupe_20"
                            data-name="Groupe 20"
                            transform="translate(0 7.685)"
                          >
                            <line
                              id="Ligne_36"
                              data-name="Ligne 36"
                              x2="41.966"
                              y2="25.449"
                              transform="translate(0 1)"
                              fill="none"
                              stroke="#fff"
                              stroke-width="4"
                            />
                            <line
                              id="Ligne_37"
                              data-name="Ligne 37"
                              y1="26.449"
                              x2="41.966"
                              transform="translate(0 0)"
                              fill="none"
                              stroke="#fff"
                              stroke-width="4"
                            />
                          </g>
                          <path
                            id="Tracé_11"
                            data-name="Tracé 11"
                            d="M0-8.452s10.438-9.686,20.93-9.686S41.966-8.452,41.966-8.452"
                            transform="translate(0 18.138)"
                            fill="none"
                            stroke="#fff"
                            stroke-width="4"
                          />
                        </g>
                      </svg>
                    </template>
                    <template v-if="item.svg == 2">
                      <svg
                        :style="{
                          filter: 'contrast(0)',
                        }"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        viewBox="0 0 42.934 10.068"
                      >
                        <path
                          id="Tracé_12"
                          data-name="Tracé 12"
                          d="M0-11.769s10.153-6.369,20.357-6.369,20.46,6.369,20.46,6.369"
                          transform="translate(1.063 20.138)"
                          fill="none"
                          stroke="#fff"
                          stroke-width="4"
                        />
                      </svg>
                    </template>
                    <template v-if="item.svg == 3">
                      <svg
                        :style="{
                          filter: 'contrast(0)',
                        }"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        viewBox="0 0 44.729 13.386"
                      >
                        <path
                          id="Tracé_13"
                          data-name="Tracé 13"
                          d="M0,0S10.473,9.932,20.968,9.932,41.979,0,41.979,0"
                          transform="translate(1.376 1.454)"
                          fill="none"
                          stroke="#fff"
                          stroke-width="4"
                        />
                      </svg>
                    </template>
                  </div>

                  <div
                    :style="`width:${
                      videoDuration * base_rate * settings.fontSize
                    }px;position:relative;height:${rythmoElementHeight}px;`"
                  >
                    <!-- Mode simple bande (mode normal) -->
                    <div
                      v-if="!doubleBandMode"
                      class="timeline-cell"
                      id="timeline"
                      @click="scrollToTimeline"
                      :style="`left:${offsetDuration * 100}px;
                        position:relative;width:100%;background-image:url(${
                          settings.backgroundImage
                        });background-size:contain;background-repeat-x:repeat;background-repeat: repeat-x;height:${
                        settings.height
                      }px;z-index:100;`"
                    >
                      <div
                        style="position: absolute; width: 100%; height: 50px"
                        class="rythmo-ruban"
                      ></div>
                      <template v-for="(subtitle, b) in visibleSubtitles">
                        <!-- Indicateur d'enregistrement pour le sous-titre -->
                        <div
                          v-if="
                            isRecording && isRecordingForSubtitle(subtitle)
                          "
                          :style="getRecordingIndicatorStyle(subtitle)"
                          :key="`rec-indicator-${b}`"
                          class="recording-indicator-rythmo"
                        >
                          <div class="recording-pulse"></div>
                          <span class="recording-label">REC</span>
                        </div>

                        <!-- Indicateur de personnage en session -->
                        <div
                          v-if="
                            !isRecording &&
                            selectedCharacter &&
                            subtitle.character === selectedCharacter &&
                            recordingSettings.followSubtitles
                          "
                          :style="getSessionCharacterIndicatorStyle(subtitle)"
                          :key="`session-indicator-${b}`"
                          class="session-character-indicator"
                        >
                          <v-icon x-small color="white"
                            >mdi-account-voice</v-icon
                          >
                        </div>

                        <!-- Composant De Dialogue -->
                        <DialogueComponent
                          @click="
                            selectedSubtitle = subtitle;
                            subtitle.active = true;
                          "
                          @changeToLine="changeToLine"
                          :cursorTime="cursorTime"
                          :selectedSubtitle="selectedSubtitle"
                          :settings="settings"
                          :characterColor="
                            settings.charactersColors[subtitle.character]
                          "
                          :zoom="zoom"
                          :singleLine="singleLine"
                          :cutMode="cutMode"
                          :spaces="
                            fontFamily.find(
                              (map) => map.value == settings.fontFamily
                            ).spaces
                          "
                          :saveInProgress="saveInProgress"
                          @cutSubtitle="cutSubtitle"
                          :offsetDuration="offsetDuration"
                          :character="subtitle.character"
                          :darkMode="darkMode"
                          :fontFamily="fontFamily"
                          @updateSubtitle="updateSubtitle"
                          :subtitle="subtitle"
                          :id="subtitle.id"
                          :videoDuration="videoDuration"
                          :key="`dialg${b}`"
                        />
                      </template>
                    </div>

                    <!-- Mode double bande (nouveau) -->
                    <div
                      v-if="doubleBandMode"
                      :style="`width:100%;height:${rythmoElementHeight}px;position:relative;`"
                    >
                      <!-- Bande supérieure - Langue source -->
                      <div
                        :style="`position:absolute;top:0;left:0;right:0;height:${
                          (rythmoElementHeight * rythmoSplitRatio) / 100
                        }px;background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%);border-bottom:2px solid rgba(255,255,255,0.3);overflow:hidden;`"
                      >
                        <div class="rythmo-band-header source">
                          <v-icon x-small color="white" class="mr-1"
                            >mdi-lock-outline</v-icon
                          >
                          <span
                            >{{ sourceLang.toUpperCase() }} - Original</span
                          >
                        </div>
                        <div
                          class="timeline-cell source-band"
                          id="timeline-source"
                          @click="scrollToTimeline"
                          :style="`position:relative;left:${
                            offsetDuration * 100
                          }px;width:${
                            videoDuration * base_rate * settings.fontSize
                          }px;background-image:url(${
                            settings.backgroundImage
                          });background-size:auto ${
                            settings.height
                          }px;background-position: left center;background-repeat-x:repeat;height:100%;overflow:visible;`"
                        >
                          <template
                            v-for="(subtitle, b) in visibleSourceSubtitles"
                          >
                            <DialogueComponentReadOnly
                              :settings="getSettingsForBand('source')"
                              :zoom="zoom"
                              :singleLine="singleLine"
                              :offsetDuration="offsetDuration"
                              :character="subtitle.character"
                              :darkMode="darkMode"
                              :fontFamily="fontFamily"
                              :subtitle="subtitle"
                              :videoDuration="videoDuration"
                              :key="`dialg-source-${b}`"
                            />
                          </template>
                        </div>
                      </div>

                      <!-- Bande inférieure - Langue cible -->
                      <div
                        :style="`position:absolute;top:${
                          (rythmoElementHeight * rythmoSplitRatio) / 100
                        }px;left:0;right:0;height:${
                          (rythmoElementHeight * (100 - rythmoSplitRatio)) /
                          100
                        }px;background: linear-gradient(180deg, #27513a 0%, #3e7254 100%);overflow:hidden;`"
                      >
                        <div class="rythmo-band-header target">
                          <v-icon x-small color="white" class="mr-1"
                            >mdi-pencil-outline</v-icon
                          >
                          <span
                            >{{ targetLang.toUpperCase() }} - Traduction</span
                          >
                        </div>
                        <div
                          class="timeline-cell target-band"
                          id="timeline-target"
                          @click="scrollToTimeline"
                          :style="`position:relative;left:${
                            offsetDuration * 100
                          }px;width:${
                            videoDuration * base_rate * settings.fontSize
                          }px;background-image:url(${
                            settings.backgroundImage
                          });background-size:auto ${
                            settings.height
                          }px;background-position: left center;background-repeat-x:repeat;height:100%;overflow:visible;`"
                        >
                          <template
                            v-for="(subtitle, b) in visibleTargetSubtitles"
                          >
                            <DialogueComponent
                              @click="
                                selectedSubtitle = subtitle;
                                subtitle.active = true;
                              "
                              @changeToLine="changeToLine"
                              :cursorTime="cursorTime"
                              :selectedSubtitle="selectedSubtitle"
                              :settings="getSettingsForBand('target')"
                              :characterColor="
                                settings.charactersColors[subtitle.character]
                              "
                              :zoom="zoom"
                              :singleLine="singleLine"
                              :cutMode="cutMode"
                              :spaces="
                                fontFamily.find(
                                  (map) => map.value == settings.fontFamily
                                ).spaces
                              "
                              :saveInProgress="saveInProgress"
                              @cutSubtitle="cutSubtitle"
                              :offsetDuration="offsetDuration"
                              :character="subtitle.character"
                              :darkMode="darkMode"
                              :fontFamily="fontFamily"
                              @updateSubtitle="updateSubtitle"
                              :subtitle="subtitle"
                              :id="subtitle.id"
                              :videoDuration="videoDuration"
                              :key="`dialg-target-${b}`"
                              :disableDrag="true"
                            />
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :style="`width:${innerWidth / 2}px;display:inline-block;`"
                >
                  <div style="height: 15px" class="timeline-cell"></div>
                  <div
                    class="timeline-cell"
                    id="timeline"
                    @click="scrollToTimeline"
                    :style="`left:${
                      offsetDuration * 100
                    }px;position:relative;width:100%;background-color:${choseColorBySeedString()};height:${
                      settings.height
                    }px;`"
                  ></div>
                </div>
              </div>
            </div>
        </v-col>
      </div>
    </div>
    <!-- ToolBar -->
    <div
      cols="12"
      style="position: absolute; z-index: 100; width: 100%"
      class="py-0 mb-0"
      v-if="!rendering && selectedSubtitle.id && cinemaMode && !isRecording"
    >
      <v-card>
        <v-card-text>
          <v-row class="my-0">
            <v-col lg="2" cols="10" class="my-0">
              <!-- <v-text-field hide-details v-model="selectedSubtitle.character" outlined dense /> -->
              <v-text-field
                label="character"
                dense
                outlined
                hide-details
                v-model="selectedSubtitle.character"
              >
                <template v-slot:append>
                  <v-menu>
                    <template v-slot:activator="{ on }">
                      <v-btn small icon color="primary" v-on="on">
                        <v-icon small> mdi-chevron-down </v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="i in getArrayOfAvailableCharacter"
                        @click="selectedCharacter = i"
                        :key="`charaarray${i}`"
                      >
                        {{ i }}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" class="my-0">
              <v-text-field
                hide-details
                v-model="selectedSubtitle.text"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-btn
            small
            @click="
              deleteSubtitle(selectedSubtitle.id);
              selectedSubtitle = { id: null };
            "
            color="red"
            icon
            style="position: absolute; right: 2em; top: 0; cursor: pointer"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <!-- close button -->
          <v-btn
            small
            @click="selectedSubtitle = { id: null }"
            color="primary"
            icon
            style="position: absolute; right: 0em; top: 0; cursor: pointer"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
  </div>
  <!-- Render Window -->
  <v-dialog
    v-model="renderDone"
    max-width="800px"
    max-height="70vh"
    persistent
  >
    <v-card class="render-dialog" dark>
      <!-- Header -->
      <v-app-bar flat color="success" dark class="render-header" dense>
        <v-icon left>mdi-check-circle</v-icon>
        <v-toolbar-title class="font-weight-bold">
          {{ $t("title.render_done") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="renderDone = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text class="render-content pa-4">
        <v-row>
          <!-- Video Preview -->
          <v-col cols="12" md="7">
            <div class="video-preview-container">
              <video
                crossorigin="anonymous"
                ref="outputVideo"
                v-if="outputURL"
                class="preview-video"
                :src="outputURL"
                controls
              ></video>
              <div v-else class="video-placeholder">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="40"
                ></v-progress-circular>
                <p class="mt-2 mb-0">Chargement...</p>
              </div>
            </div>
          </v-col>

          <!-- Video Info & Actions -->
          <v-col cols="12" md="5">
            <div class="render-info-container">
              <!-- Success Message -->
              <div class="success-message text-center mb-4">
                <v-icon color="success" size="48" class="mb-2"
                  >mdi-check-circle-outline</v-icon
                >
                <h3 class="success--text font-weight-bold mb-1">
                  Vidéo prête !
                </h3>
                <p class="text-caption grey--text text--lighten-1 mb-0">
                  {{ $t("title.render_done_subtitle") }}
                </p>
              </div>

              <!-- Compact Video Stats -->
              <v-card class="video-stats mb-4" outlined flat>
                <v-card-text class="pa-3">
                  <div class="stats-grid">
                    <div class="stat-item">
                      <v-icon small class="mr-1">mdi-clock-outline</v-icon>
                      <span class="text-caption">{{
                        formatDuration($refs.outputVideo?.duration)
                      }}</span>
                    </div>
                    <div class="stat-item">
                      <v-icon small class="mr-1">mdi-monitor</v-icon>
                      <span class="text-caption"
                        >{{ $refs.outputVideo?.videoWidth }}×{{
                          $refs.outputVideo?.videoHeight
                        }}</span
                      >
                    </div>
                    <div class="stat-item">
                      <v-icon small class="mr-1">mdi-file-video</v-icon>
                      <span class="text-caption">MP4</span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Actions -->
              <div class="actions-container">
                <v-btn
                  large
                  block
                  color="success"
                  elevation="2"
                  @click="downloadRenderVideo()"
                  class="download-btn mb-3"
                >
                  <v-icon left>mdi-download</v-icon>
                  {{ $t("button.download") }}
                </v-btn>

                <v-row dense>
                  <v-col cols="6">
                    <v-btn
                      outlined
                      block
                      color="primary"
                      @click="shareVideo()"
                      small
                    >
                      <v-icon left small>mdi-share-variant</v-icon>
                      Partager
                    </v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn outlined block @click="renderDone = false" small>
                      <v-icon left small>mdi-close</v-icon>
                      Fermer
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Overlay Rendering -->
  <v-overlay :value="rendering" class="text-center">
    <h2>
      {{ renderStatusMessage }}
    </h2>
    <template v-if="renderProgress"> {{ renderProgress }}% </template>
    <template v-else>
      {{ $t("title.export_in_prepare") }}
    </template>
    <h3>Don't close or resize this window</h3>
    <v-progress-linear indeterminate></v-progress-linear>
  </v-overlay>
  <!-- Overlay timer -->
  <v-overlay :value="timer > 0">
    <h1 class="display-1">
      {{ timer }}
    </h1>
  </v-overlay>
  <!-- Popup plan -->
  <v-dialog
    v-model="openPopupPlan"
    max-width="1200"
    width="95%"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card dark>
      <v-btn
        icon
        dark
        @click="openPopupPlan = false"
        class="dialog-close-btn"
        style="position: absolute; right: 16px; top: 16px; z-index: 10"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text class="pa-0">
        <plan-view :reason="reasonPlan" />
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Settings -->
  <v-dialog
    v-model="openSettings"
    max-width="900px"
    transition="dialog-transition"
  >
    <v-card class="settings-dialog">
      <!-- Header moderne avec gradient -->
      <v-app-bar flat color="transparent" class="settings-header">
        <v-icon left color="primary">mdi-cog</v-icon>
        <v-toolbar-title class="font-weight-bold">{{
          $t("title.settings")
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="openSettings = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text class="pa-0">
        <!-- Tabs pour organiser les sections -->
        <v-tabs
          v-model="settingsTab"
          background-color="transparent"
          color="primary"
          grow
        >
          <v-tab>
            <v-icon left small>mdi-format-text</v-icon>
            Texte
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-palette</v-icon>
            Apparence
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-account-group</v-icon>
            Personnages
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="settingsTab" class="home-settings-content">
          <!-- Tab 1: Paramètres de texte -->
          <v-tab-item class="scrollable-tab-item">
            <v-container fluid class="pa-6">
              <v-row>
                <!-- Preview en temps réel -->
                <v-col cols="12" class="mb-4">
                  <v-card class="preview-card" elevation="0">
                    <v-card-title class="pb-2">
                      <v-icon small class="mr-2">mdi-eye</v-icon>
                      Aperçu en temps réel
                    </v-card-title>
                    <v-card-text>
                      <div class="preview-container">
                        <div
                          class="preview-text"
                          :style="{
                            fontFamily: settings.fontFamily,
                            fontSize: `${settings.fontSize}px`,
                            color: settings.fontColor || '#ffffff',
                          }"
                        >
                          Voici à quoi ressembleront vos sous-titres
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Sélection de police -->
                <v-col cols="12" md="6">
                  <div class="setting-group">
                    <div class="setting-header">
                      <v-icon small color="primary">mdi-format-font</v-icon>
                      <span class="font-weight-medium ml-2"
                        >Police d'écriture</span
                      >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="ml-1" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span>Choisissez la police pour vos sous-titres</span>
                      </v-tooltip>
                    </div>
                    <v-select
                      :items="fontFamily"
                      v-model="settings.fontFamily"
                      item-text="text"
                      item-value="value"
                      outlined
                      dense
                      class="mt-2"
                    >
                      <template v-slot:selection="{ item }">
                        <span :style="{ fontFamily: item.value }">
                          {{ item.text }}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <div
                          class="font-preview-item"
                          :style="{ fontFamily: item.value }"
                        >
                          <span class="font-name">{{ item.text }}</span>
                          <span class="font-sample">Aa Bb Cc 123</span>
                        </div>
                      </template>
                    </v-select>
                  </div>
                </v-col>

                <!-- Taille de police -->
                <v-col cols="12" md="6">
                  <div class="setting-group">
                    <div class="setting-header">
                      <v-icon small color="primary">mdi-format-size</v-icon>
                      <span class="font-weight-medium ml-2"
                        >Taille du texte</span
                      >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="ml-1" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >Ajustez la taille des sous-titres (10-50px)</span
                        >
                      </v-tooltip>
                    </div>
                    <v-slider
                      v-model="settings.fontSize"
                      :min="10"
                      :max="50"
                      :step="1"
                      thumb-label="always"
                      color="primary"
                      track-color="grey"
                      class="mt-4"
                    >
                      <template v-slot:append>
                        <v-text-field
                          v-model="settings.fontSize"
                          type="number"
                          :min="10"
                          :max="50"
                          style="width: 60px"
                          dense
                          outlined
                          hide-details
                          suffix="px"
                        ></v-text-field>
                      </template>
                    </v-slider>
                  </div>
                </v-col>

                <!-- Couleur du texte -->
                <v-col cols="12" md="6">
                  <div class="setting-group">
                    <div class="setting-header">
                      <v-icon small color="primary">mdi-palette</v-icon>
                      <span class="font-weight-medium ml-2"
                        >Couleur du texte</span
                      >
                    </div>
                    <div class="color-picker-grid mt-3">
                      <div
                        v-for="color in fontColors"
                        :key="color.color"
                        class="color-option"
                        :class="{
                          active: settings.fontColor === color.color,
                        }"
                        :style="{ backgroundColor: color.color }"
                        @click="settings.fontColor = color.color"
                      >
                        <v-icon
                          v-if="settings.fontColor === color.color"
                          small
                          >mdi-check</v-icon
                        >
                      </div>
                    </div>
                  </div>
                </v-col>

                <!-- Langue -->
                <v-col cols="12" md="6">
                  <div class="setting-group">
                    <div class="setting-header">
                      <v-icon small color="primary">mdi-translate</v-icon>
                      <span class="font-weight-medium ml-2"
                        >Langue des sous-titres</span
                      >
                    </div>
                    <v-select
                      :items="getAvailableLanguage"
                      v-model="settings.language"
                      outlined
                      dense
                      class="mt-2"
                    ></v-select>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- Tab 2: Apparence et backgrounds -->
          <v-tab-item class="scrollable-tab-item">
            <v-container fluid class="pa-6">
              <v-row>
                <!-- Affichage des sous-titres sur la vidéo -->
                <v-col cols="12">
                  <div class="setting-group">
                    <div class="setting-header">
                      <v-icon small color="primary"
                        >mdi-subtitles-outline</v-icon
                      >
                      <span class="font-weight-medium ml-2"
                        >Affichage des sous-titres</span
                      >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="ml-1" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >Afficher ou masquer les sous-titres directement sur
                          la vidéo</span
                        >
                      </v-tooltip>
                    </div>
                    <v-switch
                      v-model="settings.showVideoSubtitles"
                      label="Afficher les sous-titres sur la vidéo"
                      hint="Désactivez pour masquer l'overlay des sous-titres sur le lecteur vidéo"
                      persistent-hint
                      color="primary"
                      class="mt-2"
                    ></v-switch>
                  </div>
                </v-col>

                <!-- Filtres de thèmes -->
                <v-col cols="12">
                  <div class="setting-group">
                    <div class="setting-header mb-3">
                      <v-icon small color="primary">mdi-filter</v-icon>
                      <span class="font-weight-medium ml-2"
                        >Filtrer les styles</span
                      >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="ml-1" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >Sélectionnez les catégories de fonds à
                          afficher</span
                        >
                      </v-tooltip>
                    </div>
                    <v-chip-group
                      v-model="selectedThemes"
                      multiple
                      column
                      active-class="primary--text"
                    >
                      <v-chip
                        v-for="(count, theme) in backgrounds"
                        :key="theme"
                        :value="theme"
                        filter
                        outlined
                        class="ma-1"
                      >
                        <v-icon left small>mdi-palette-swatch</v-icon>
                        {{ theme }} ({{ count }})
                      </v-chip>
                    </v-chip-group>
                  </div>
                </v-col>

                <!-- Grille de backgrounds -->
                <v-col cols="12">
                  <div class="setting-group">
                    <div class="setting-header mb-3">
                      <v-icon small color="primary">mdi-image</v-icon>
                      <span class="font-weight-medium ml-2"
                        >Choisir un fond</span
                      >
                    </div>
                    <v-row>
                      <v-col
                        v-for="(background, i) in filteredBackgrounds"
                        :key="i"
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                      >
                        <v-hover v-slot="{ hover }">
                          <v-card
                            @click="
                              settings.backgroundImage = background.path;
                              openSettings = false;
                            "
                            class="background-option"
                            :class="{
                              selected:
                                settings.backgroundImage === background.path,
                            }"
                            :elevation="hover ? 8 : 2"
                          >
                            <div
                              class="background-preview"
                              :style="{
                                backgroundImage: `url(${background.path})`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'repeat-x',
                                backgroundPosition: 'center center',
                                height: '120px',
                                position: 'relative',
                                overflow: 'hidden',
                              }"
                            >
                              <div
                                class="preview-overlay"
                                v-if="
                                  settings.backgroundImage === background.path
                                "
                              >
                                <v-icon color="success" large>
                                  mdi-check-circle
                                </v-icon>
                              </div>
                              <div class="preview-text-example">
                                <span
                                  :style="{
                                    fontFamily: settings.fontFamily,
                                    fontSize: '16px',
                                    color: settings.fontColor || '#ffffff',
                                  }"
                                >
                                  Exemple de texte
                                </span>
                              </div>
                            </div>
                            <v-card-text class="text-center py-2">
                              <small>{{ background.name }}</small>
                            </v-card-text>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- Tab 3: Personnages -->
          <v-tab-item class="scrollable-tab-item">
            <v-container fluid class="pa-6">
              <v-row>
                <v-col cols="12">
                  <div class="setting-group">
                    <div class="setting-header mb-3">
                      <v-icon small color="primary">mdi-account-edit</v-icon>
                      <span class="font-weight-medium ml-2"
                        >Couleurs des personnages</span
                      >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon small class="ml-1" v-on="on"
                            >mdi-help-circle-outline</v-icon
                          >
                        </template>
                        <span
                          >Attribuez une couleur unique à chaque
                          personnage</span
                        >
                      </v-tooltip>
                    </div>

                    <!-- Liste des personnages -->
                    <v-list class="character-list">
                      <v-list-item
                        v-for="character in getArrayOfAvailableCharacter"
                        :key="character"
                        class="character-item"
                        @click="selectedCharacter = character"
                        :class="{ active: selectedCharacter === character }"
                      >
                        <v-list-item-avatar>
                          <v-avatar
                            :color="
                              settings.charactersColors[character] || '#666'
                            "
                            size="40"
                          >
                            <span class="white--text font-weight-bold">
                              {{ character.charAt(0).toUpperCase() }}
                            </span>
                          </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium">
                            {{ character }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ countSubtitlesForCharacter(character) }}
                            sous-titres
                          </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action class="d-flex flex-row">
                          <v-menu
                            v-model="colorMenus[character]"
                            :close-on-content-click="false"
                            offset-x
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" @click.stop title="Couleur du texte">
                                <v-icon>mdi-format-color-text</v-icon>
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title class="text-subtitle-2 pb-0">Couleur du texte</v-card-title>
                              <v-card-text>
                                <v-color-picker
                                  :value="
                                    settings.charactersColors[character]
                                  "
                                  @update:color="
                                    updateColor(character, $event)
                                  "
                                  dot-size="25"
                                  mode="hexa"
                                  swatches-max-height="200"
                                ></v-color-picker>
                              </v-card-text>
                            </v-card>
                          </v-menu>
                          <v-menu
                            v-model="badgeColorMenus[character]"
                            :close-on-content-click="false"
                            offset-x
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn icon v-on="on" @click.stop title="Couleur du badge">
                                <v-icon>mdi-label</v-icon>
                              </v-btn>
                            </template>
                            <v-card>
                              <v-card-title class="text-subtitle-2 pb-0">Couleur du badge</v-card-title>
                              <v-card-text>
                                <v-color-picker
                                  :value="
                                    settings.charactersBadgeColors[character]
                                  "
                                  @update:color="
                                    updateBadgeColor(character, $event)
                                  "
                                  dot-size="25"
                                  mode="hexa"
                                  swatches-max-height="200"
                                ></v-color-picker>
                              </v-card-text>
                            </v-card>
                          </v-menu>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <!-- Footer avec actions -->
      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-btn text @click="resetSettings">
          <v-icon left small>mdi-refresh</v-icon>
          Réinitialiser
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="openSettings = false"> Annuler </v-btn>
        <v-btn color="primary" @click="applySettings">
          <v-icon left small>mdi-check</v-icon>
          Appliquer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Loading -->
  <v-overlay :value="loading">
    <h2>
      {{ $t("title.loading") }}
    </h2>
    <v-progress-linear indeterminate></v-progress-linear>
  </v-overlay>
  <!-- Tasks -->
  <TaskManager
    v-model="taskPopup"
    :tasks="tasks"
    @delete-task="deleteTask"
    @update-tasks="updateTasksFromChild"
    @load-render-video="loadRenderVideo"
  />
  <!-- confirmLeave dialog -->
  <v-dialog v-model="confirmLeavePopup" persistent max-width="50vw">
    <v-card>
      <v-card-title class="headline">
        {{ $t("title.confirm_leave") }}
      </v-card-title>
      <v-card-text>
        {{ $t("text.confirm_leave") }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="confirmLeavePopup = false">
          {{ $t("title.stay") }}
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="
            confirmLeave = true;
            confirmLeavePopup = false;
            $router.push(nextRoute);
          "
        >
          {{ $t("title.leave") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Help Window -->
  <v-dialog
    v-model="openHelpWindow"
    :max-height="innerHeight > 600 ? '80vh' : '100vh'"
  >
    <v-card>
      <help-section />
    </v-card>
  </v-dialog>
  <!-- export Window -->
  <v-dialog
    v-model="popupExport"
    :max-width="innerWidth > 600 ? '50vw' : '100vw'"
  >
    <v-card>
      <v-card-text>
        <v-row class="mx-3" v-if="$refs.video">
          <v-col v-if="$refs.video.duration > 10 * 60" cols="12">
            <v-alert type="warning" dismissible>
              {{ $t("error.export_warning") }}
            </v-alert>
          </v-col>
          <v-col cols="12">
            <!-- Choose export mode between Youtube and Tiktok with radio  -->
            Format
            <v-radio-group v-model="exportMode" row>
              <v-radio
                label="Youtube (Paysage) - 1920x1080"
                value="youtube"
              ></v-radio>
              <v-radio
                label="Tiktok (Portrait) - 1080x1920"
                value="tiktok"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            Filtre AI
            <v-checkbox
              v-model="settings.iafilter"
              :label="$t('options.denoise_audio')"
            ></v-checkbox>
          </v-col>
          <v-col cols="6">
            {{ $t("options.without_rythmo") }}
            <v-checkbox
              v-model="settings.without_rythmo"
              :label="$t('options.without_rythmo')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" v-if="hasProcessedAudio">
            <v-alert type="info" dense>
              <v-icon left>mdi-microphone-off</v-icon>
              Audio sans voix disponible
            </v-alert>
            <v-checkbox
              v-model="settings.useProcessedAudio"
              label="Utiliser l'audio sans voix pour l'export"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <!-- preroll -->
            Pre-roll<br />
            <v-btn
              v-for="i in [0, 1, 2, 3]"
              :key="i"
              :color="settings.preroll == i ? 'primary' : null"
              @click="settings.preroll = i"
            >
              {{ i }}s
            </v-btn>
          </v-col>
          <v-col cols="12">
            Frame Rate
            <v-select
              :items="framerates"
              v-model="settings.framerate"
              label="Framerate"
              value="value"
              hide-details
              @change="checkFrameratePlan()"
            >
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          @click="
            createExportTask();
            popupExport = false;
          "
        >
          Exporter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Save in progress -->
  <v-overlay v-if="false" :value="saveInProgress" class="text-center">
    <h2>
      {{ $t("title.saving") }}
    </h2>
    <!-- scroled tips -->
    <transition-group name="fade">
      <div v-for="(tip, b) in tips" :key="tip">
        <div v-if="tip.show" :key="`tip${b}`" class="tip">
          <v-alert dense color="primary" class="white--text" type="info">
            {{ tip.text }}
          </v-alert>
        </div>
      </div>
    </transition-group>
    <v-progress-linear :value="uploadProgress"></v-progress-linear>
  </v-overlay>
  <v-snackbar v-model="snackbar" :timeout="5000" :color="snackbarColor || 'success'" top>
    {{ snackbarMessage }}
  </v-snackbar>

  <!-- Dialog Export Croisillé -->
  <v-dialog v-model="detxExportDialog" max-width="600px">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon left dark>mdi-grid</v-icon>
        Export Croisillé
      </v-card-title>

      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="12">
            <div class="text-body-1 mb-3">
              Sélectionnez le format d'export pour votre croisillé :
            </div>
          </v-col>

          <v-col cols="12">
            <v-radio-group v-model="detxExportFormat" column>
              <v-radio value="pdf" color="red">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="red">mdi-file-pdf-box</v-icon>
                    <div>
                      <div class="text-subtitle-1">PDF</div>
                      <div class="text-caption">
                        Document formaté avec grille, rôles et script
                      </div>
                    </div>
                  </div>
                </template>
              </v-radio>

              <v-radio value="excel" color="green">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="green">mdi-microsoft-excel</v-icon>
                    <div>
                      <div class="text-subtitle-1">Excel</div>
                      <div class="text-caption">
                        Classeur avec 3 feuilles (Grille, Rôles, Script)
                      </div>
                    </div>
                  </div>
                </template>
              </v-radio>

              <v-radio value="csv" color="blue">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="blue">mdi-file-delimited</v-icon>
                    <div>
                      <div class="text-subtitle-1">CSV</div>
                      <div class="text-caption">
                        Format tabulaire pour import dans d'autres outils
                      </div>
                    </div>
                  </div>
                </template>
              </v-radio>

              <v-radio value="json" color="purple">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="purple">mdi-code-json</v-icon>
                    <div>
                      <div class="text-subtitle-1">JSON</div>
                      <div class="text-caption">
                        Données structurées (affichées dans la console)
                      </div>
                    </div>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12">
            <v-alert v-if="detxData" type="info" dense outlined>
              <v-icon left small>mdi-check-circle</v-icon>
              Données DETX disponibles :
              {{ detxData.statistics.totalRoles }} rôles,
              {{ detxData.statistics.totalLines }} lignes
            </v-alert>
            <v-alert
              v-else-if="subtitles.length"
              type="warning"
              dense
              outlined
            >
              <v-icon left small>mdi-alert</v-icon>
              Génération depuis {{ subtitles.length }} sous-titres existants
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="detxExportDialog = false"> Annuler </v-btn>
        <v-btn color="primary" @click="performCroisilleExport">
          <v-icon left>mdi-export</v-icon>
          Exporter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="inviteFriendModal">
    <InviteFriend :id_project="workspace" :settings="settings" />
  </v-dialog>
  <!-- bulk edit subtitles dialog with offset start/end -->
  <v-dialog v-model="bulkEdit" max-width="500px">
    <v-card>
      <v-card-title>
        <v-toolbar dense flat>
          <v-toolbar-title>{{ $t("title.bulk_edit") }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="bulkEdit = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-row>
          <!-- change character (select character) -->
          <v-col cols="12">
            <v-select
              :items="getArrayOfAvailableCharacter"
              label="Character"
              outlined
              dense
              v-model="selectedCharacter"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <!-- change lines -->
            <v-select
              :items="[0, 1, 2, 3]"
              label="Lines"
              outlined
              dense
              v-model="selectedLineChange"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field
              label="Offset Start (in s)"
              v-model="offsetStart"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="
            bulkEditSubtitles(offsetStart);
            bulkEdit = false;
          "
        >
          {{ $t("button.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Dialogue de remplacement vidéo sans voix -->
  <v-dialog
    v-model="replaceVideoDialog"
    max-width="600px"
    persistent
    :retain-focus="false"
  >
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon left dark>mdi-microphone-variant-off</v-icon>
        Remplacer la vidéo par une version sans voix
      </v-card-title>

      <v-stepper v-model="replaceVideoStep" elevation="0">
        <v-stepper-header>
          <v-stepper-step
            :complete="replaceVideoStep > 1"
            step="1"
            color="primary"
          >
            Information
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :complete="replaceVideoStep > 2"
            step="2"
            color="warning"
          >
            Confirmation
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="3" color="error"> Traitement </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <!-- Étape 1: Information -->
          <v-stepper-content step="1">
            <v-card-text class="pa-4">
              <v-alert
                type="info"
                outlined
                prominent
                icon="mdi-information"
                class="mb-4"
              >
                <div class="text-subtitle-1 font-weight-bold mb-2">
                  Cette fonction utilise l'IA pour supprimer les voix de votre
                  vidéo
                </div>
                <div class="text-body-2">
                  Le processus va :
                  <ul class="mt-2">
                    <li>Extraire l'audio de votre vidéo</li>
                    <li>Utiliser l'IA pour isoler et supprimer les voix</li>
                    <li>
                      Recompiler la vidéo avec uniquement la musique et les
                      effets sonores
                    </li>
                    <li>Remplacer définitivement votre vidéo actuelle</li>
                  </ul>
                </div>
              </v-alert>

              <div class="d-flex align-center mb-3">
                <v-icon left color="primary">mdi-timer-sand</v-icon>
                <span class="text-body-1">
                  Temps estimé : 2-5 minutes selon la durée de votre vidéo
                </span>
              </div>

              <div class="d-flex align-center">
                <v-icon left color="primary">mdi-cloud-upload</v-icon>
                <span class="text-body-1">
                  La vidéo sera traitée sur nos serveurs
                </span>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="
                  replaceVideoDialog = false;
                  replaceVideoStep = 1;
                "
              >
                Annuler
              </v-btn>
              <v-btn color="primary" @click="replaceVideoStep = 2">
                Suivant
                <v-icon right>mdi-arrow-right</v-icon>
              </v-btn>
            </v-card-actions>
          </v-stepper-content>

          <!-- Étape 2: Confirmation -->
          <v-stepper-content step="2">
            <v-card-text class="pa-4">
              <v-alert
                type="warning"
                outlined
                prominent
                icon="mdi-alert"
                class="mb-4"
              >
                <div class="text-subtitle-1 font-weight-bold mb-2">
                  ⚠️ ACTION IRRÉVERSIBLE
                </div>
                <div class="text-body-2">
                  Une fois le traitement lancé, votre vidéo originale sera
                  <strong>définitivement remplacée</strong> par la version
                  sans voix. <br /><br />
                  Il n'y aura
                  <strong>aucun moyen de récupérer la vidéo originale</strong
                  >.
                </div>
              </v-alert>

              <v-checkbox
                v-model="confirmReplace"
                color="warning"
                class="mt-4"
              >
                <template v-slot:label>
                  <span class="text-body-2">
                    Je comprends que cette action est
                    <strong>irréversible</strong>
                    et que ma vidéo originale sera perdue
                  </span>
                </template>
              </v-checkbox>
            </v-card-text>

            <v-card-actions>
              <v-btn text @click="replaceVideoStep = 1">
                <v-icon left>mdi-arrow-left</v-icon>
                Retour
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="
                  replaceVideoDialog = false;
                  replaceVideoStep = 1;
                  confirmReplace = false;
                "
              >
                Annuler
              </v-btn>
              <v-btn
                color="error"
                @click="
                  replaceVideoStep = 3;
                  startReplaceVideo();
                "
                :disabled="!confirmReplace"
              >
                Remplacer définitivement
                <v-icon right>mdi-alert</v-icon>
              </v-btn>
            </v-card-actions>
          </v-stepper-content>

          <!-- Étape 3: Traitement -->
          <v-stepper-content step="3">
            <v-card-text class="pa-4 text-center">
              <div v-if="!replaceVideoTaskId">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  :size="80"
                  :width="7"
                  class="mb-4"
                ></v-progress-circular>

                <div class="text-h6 mb-2">Préparation du traitement...</div>
                <div class="text-body-2 text--secondary">
                  Sauvegarde du projet et lancement de la tâche
                </div>
              </div>

              <div v-else>
                <v-icon color="success" size="80" class="mb-4">
                  mdi-check-circle
                </v-icon>

                <div class="text-h6 mb-2">Traitement en cours !</div>
                <div class="text-body-2 text--secondary mb-4">
                  Votre vidéo est en cours de traitement sur nos serveurs.
                  <br />
                  Vous pouvez suivre la progression dans le panneau des
                  tâches.
                </div>

                <v-chip color="primary" outlined class="mb-4">
                  <v-icon left small>mdi-identifier</v-icon>
                  Tâche #{{ replaceVideoTaskId }}
                </v-chip>

                <div class="text-caption text--secondary">
                  La vidéo sera automatiquement rechargée une fois le
                  traitement terminé.
                </div>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="
                  replaceVideoDialog = false;
                  taskPopup = true;
                  replaceVideoStep = 1;
                  confirmReplace = false;
                "
                :disabled="!replaceVideoTaskId"
              >
                Voir les tâches
                <v-icon right>mdi-open-in-new</v-icon>
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>

  <!-- Add BWF Metadata Configuration Dialog -->
  <v-dialog v-model="bwfMetadataDialog" max-width="600">
    <v-card>
      <v-card-title>
        <span class="text-h5">Configuration des métadonnées BWF</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1 mb-2">
                Associez un nom de micro à chaque personnage pour l'export BWF
              </div>
              <div class="text-caption text-grey mb-4">
                Ces informations seront intégrées dans les métadonnées du
                fichier BWF pour faciliter l'organisation dans les studios de
                doublage
              </div>
            </v-col>
          </v-row>
          <v-row
            v-for="character in getArrayOfAvailableCharacter"
            :key="character"
          >
            <v-col cols="6">
              <v-text-field
                :label="character"
                disabled
                :prepend-icon="'mdi-account'"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="bwfMicrophoneMapping[character]"
                label="Nom du micro"
                placeholder="Ex: MIC_01, BOOTH_A"
                :prepend-icon="'mdi-microphone'"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="bwfIncludeSessionInfo"
                label="Inclure les informations de session (date, durée, etc.)"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="bwfMetadataDialog = false"> Annuler </v-btn>
        <v-btn color="primary" @click="saveBwfMetadata"> Enregistrer </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>
